/**
 * Automotive panel widgets — climate.
 */
import { registerAutomotive } from '../../registryCore';
import { num, str } from '../../helpers';
import { addIconTile, addPanelFrame, addPanelTitle, addProgressBar, finishPanel, panelBounds, panelGroup, panelTheme, textAt, } from '../panelPrimitives';
import { fitFontSizeToWidth, fluidFont } from '../../layout';
import { lines } from './shared';
registerAutomotive('climateControl', function (props, app) {
    var _a, _b;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 130);
    var group = panelGroup(app, 'climateControl', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var compact = h < 88 || w < 140;
    addPanelFrame(group, app, bounds, theme, compact);
    var contentY = addPanelTitle(group, app, bounds, theme, 'Climate');
    var temp = str(props, 'temp', (_a = lines(props, ['Auto', '22°C', 'Fan 3'])[1]) !== null && _a !== void 0 ? _a : '22°C');
    var fan = num(props, 'fan', 3);
    var autoOn = str(props, 'mode', (_b = lines(props, ['Auto', '22°C', 'Fan 3'])[0]) !== null && _b !== void 0 ? _b : 'Auto').toLowerCase() === 'auto';
    var tempSize = fluidFont(compact ? 20 : 26, bounds, 14, 30);
    var tempFit = fitFontSizeToWidth(temp, w * 0.38, tempSize, 12);
    group.add(app.text({
        text: temp,
        x: pad + 2,
        y: textAt(contentY + 4, tempFit.fontSize),
        fontSize: tempFit.fontSize,
        fontWeight: 'bold',
        fill: theme.text,
        listening: false,
    }));
    var iconSize = Math.max(compact ? 24 : 30, Math.min(w * 0.12, 34));
    var gap = 5;
    var iconsX = pad + Math.max(w * 0.38, w - (iconSize * 3 + gap * 2));
    var iconY = contentY + 2;
    addIconTile(group, app, iconsX, iconY, iconSize, '❄', true, theme);
    addIconTile(group, app, iconsX + iconSize + gap, iconY, iconSize, '♨', false, theme);
    addIconTile(group, app, iconsX + (iconSize + gap) * 2, iconY, iconSize, 'A', autoOn, theme, autoOn ? 'AUTO' : '');
    var fanBarY = iconY + iconSize + 10;
    var fanLabel = "Fan ".concat(fan);
    group.add(app.text({
        text: fanLabel,
        x: pad + 2,
        y: textAt(fanBarY, 9),
        fontSize: fluidFont(9, bounds, 7, 10),
        fill: theme.textMuted,
        listening: false,
    }));
    addProgressBar(group, app, pad, fanBarY + 12, w, compact ? 5 : 6, fan / 5, theme);
    return finishPanel(group, props, bounds, { temp: temp, fan: fan, mode: autoOn ? 'auto' : 'manual' });
});
registerAutomotive('quickSettingsPanel', function (props, app) {
    var _a;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 120);
    var group = panelGroup(app, 'quickSettingsPanel', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    addPanelFrame(group, app, bounds, theme, true);
    var startY = addPanelTitle(group, app, bounds, theme, 'Quick Settings');
    var items = (_a = props.items) !== null && _a !== void 0 ? _a : [
        { icon: 'Wi', label: 'Wi-Fi', on: true },
        { icon: 'BT', label: 'BT', on: true },
        { icon: 'AC', label: 'HVAC', on: false },
        { icon: '☀', label: 'Dim', on: true },
        { icon: '♪', label: 'Vol', on: true },
        { icon: '⎋', label: 'Disp', on: false },
    ];
    var cols = 3;
    var rows = 2;
    var gap = 6;
    var availH = pad + h - startY;
    var tile = Math.min((w - gap * (cols - 1)) / cols, (availH - gap) / rows - 2);
    items.slice(0, 6).forEach(function (item, i) {
        var col = i % cols;
        var row = Math.floor(i / cols);
        addIconTile(group, app, pad + col * (tile + gap), startY + row * (tile + gap), tile, item.icon, !!item.on, theme, tile >= 34 ? item.label : undefined);
    });
    return finishPanel(group, props, bounds, { items: items });
});
